import { useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
export function useBreakpointValue(values) {
    var theme = useMantineTheme();
    var xsBreakpoint = useMediaQuery("(min-width: ".concat(theme.breakpoints.xs, ")"));
    var smBreakpoint = useMediaQuery("(min-width: ".concat(theme.breakpoints.sm, ")"));
    var mdBreakpoint = useMediaQuery("(min-width: ".concat(theme.breakpoints.md, ")"));
    var lgBreakpoint = useMediaQuery("(min-width: ".concat(theme.breakpoints.lg, ")"));
    var xlBreakpoint = useMediaQuery("(min-width: ".concat(theme.breakpoints.xl, ")"));
    if (xlBreakpoint === true && values.xl != null) {
        return values.xl;
    }
    if (lgBreakpoint === true && values.lg != null) {
        return values.lg;
    }
    if (mdBreakpoint === true && values.md != null) {
        return values.md;
    }
    if (smBreakpoint === true && values.sm != null) {
        return values.sm;
    }
    if (xsBreakpoint === true && values.xs != null) {
        return values.xs;
    }
    return values.base;
}
